export default __webpack_public_path__ + "static/translationcost-40b5404cb1f2a99d22eab8f8fc845888.jpg";